import React from "react";
export interface Props {
  label: any;
  onClick: () => void;
  isActive: boolean;
}
const Tab = ({ label, onClick, isActive }: Props) => (
  <button
    className={`tab${isActive ? " " + "active" : ""}`}
    onClick={onClick}
    tabIndex={isActive ? 0 : -1}
    role="tab"
    aria-selected={isActive}
    aria-controls={`panel-${label}`}
  >
    {label}
  </button>
);

export default Tab;
